import { render, staticRenderFns } from "./SCBreadcrumbButton.component.vue?vue&type=template&id=5d45ef15&scoped=true&"
import script from "./SCBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./SCBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./SCBreadcrumbButton.component.vue?vue&type=style&index=0&id=5d45ef15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45ef15",
  null
  
)

export default component.exports